export default __webpack_public_path__ + "static/media/IMG_0839.dff93ab7.jpeg";